module.exports = __webpack_public_path__ + "img/pers.aa2099de.png";